import styled from '@emotion/styled';
import React from 'react';
import { token } from '@atlaskit/tokens';

interface LoadingPlaceholderStyledProps {
  width: number;
  height: number;
}
const LoadingPlaceholderStyled = styled.div<LoadingPlaceholderStyledProps>`
  @keyframes placeHolderShimmer {
    0% {
      background-position: -800px 0;
    }
    100% {
      background-position: 800px 0;
    }
  }
  animation-duration: 2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: placeHolderShimmer;
  background: ${token('color.background.neutral.subtle.hovered', '#f4f5f7')};
  background: linear-gradient(
    to right,
    ${token('color.background.neutral.subtle.hovered', '#f4f5f7')} 5%,
    ${token('color.background.neutral.hovered', '#ededed')} 20%,
    ${token('color.background.neutral.subtle.hovered', '#f4f5f7')} 10%
  );
  background-size: 800px 104px;
  height: 20px;
  width: ${(props) => props.width}px;
  max-width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  max-height: ${(props) => props.height}px;
  min-height: ${(props) => props.height}px;
  position: relative;
  margin-bottom: 5px;
`;

export const CCLoadingPlaceholder = ({ width, height }: { width: number; height: number }) => {
  return <LoadingPlaceholderStyled width={width} height={height}></LoadingPlaceholderStyled>;
};
